import type { IconNode } from '../types';

/**
 * @name bell-concierge-dot
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxOSIgY3k9IjkiIHI9IjMiIC8+CiAgPHBhdGggZD0iTTIgMThhMiAyIDAgMCAxIDItMmgxNmEyIDIgMCAwIDEgMiAydjJIMloiIC8+CiAgPHBhdGggZD0iTTEyIDR2NGMtNC40IDAtOCAzLjYtOCA4IiAvPgogIDxwYXRoIGQ9Ik0xMCA0aDQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/bell-concierge-dot
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bellConciergeDot: IconNode = [
  ['circle', { cx: '19', cy: '9', r: '3', key: 'rgq500' }],
  ['path', { d: 'M2 18a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2H2Z', key: '6f9xpm' }],
  ['path', { d: 'M12 4v4c-4.4 0-8 3.6-8 8', key: '1ep1y2' }],
  ['path', { d: 'M10 4h4', key: '1xpv9s' }],
];

export default bellConciergeDot;
